import { createContext, useContext } from 'react';

import { useCheckoutState as useCheckoutStateHook } from '../../hooks';

import type { CheckoutContextValue } from '../../types';
import type { ReactNode } from 'react';

const CheckoutContext = createContext<CheckoutContextValue | null>(null);

interface CheckoutProviderProps {
  children: ReactNode;
}

/**
 * Provider for checkout/cart operations
 * THIN provider - delegates all logic to useCheckoutState composition hook
 */
export function CheckoutProvider({ children }: CheckoutProviderProps) {
  const state = useCheckoutStateHook();

  // React 19: Direct context syntax (no .Provider)
  return (
    <CheckoutContext value={state}>
      {children}
    </CheckoutContext>
  );
}

/**
 * Hook to access checkout state
 * Must be used within CheckoutProvider
 */
export function useCheckout(): CheckoutContextValue {
  const context = useContext(CheckoutContext);
  if (!context) {
    throw new Error('useCheckout must be used within a CheckoutProvider');
  }
  return context;
}
